const lpHeader = function () {
    const lpHeaderNavMobile = $('.lp-header__nav--mobile');
    if (lpHeaderNavMobile.length) {
        $('.lp-header__nav-icon').addClass('lp-header__nav-icon--visible');
    }
}

export default lpHeader;